import SearchBar from "../components/SearchBar";
import BookList from "../components/BookList";
import { OLD_TESTAMENT } from "../data/books";

export default function OldTestament() {
  return (
    <div
      data-testid="old-testament-page"
      className="max-w-5xl mx-auto px-6 py-10"
    >
      <div className="parchment-card p-7 md:p-10 fade-in">
        <p
          className="text-center"
          style={{
            fontFamily: "'IM Fell English', serif",
            fontStyle: "italic",
            color: "var(--ink-soft)",
            fontSize: "1.1rem",
            margin: "0 auto 1.2rem",
            maxWidth: "60ch",
          }}
        >
          The Old Testament, following the order and titles of the
          Douay&ndash;Rheims, with Haydock&rsquo;s commentary.
        </p>
        <div className="max-w-2xl mx-auto">
          <SearchBar />
        </div>
      </div>

      <div className="mt-14">
        <BookList
          title="THE OLD TESTAMENT"
          books={OLD_TESTAMENT}
          testId="old-testament-section"
        />
      </div>
    </div>
  );
}
